import * as Yup from 'yup';
import phoneRegex from '../../constants/regex';

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const BookADriverSchema = Yup.object()
  .shape({
    FirstName: Yup.string()
      .required('Please enter first name')
      .trim('The field cannot contain only spaces.')
      .max(50, 'First name cannot be more than 50 characters'),
    LastName: Yup.string()
      .required('Please enter last name')
      .trim('The field cannot contain only spaces.')
      .max(50, 'Last name cannot be more than 50 characters'),
    Phone: Yup.string()
      .required('Please enter phone')
      .test(
        'phone-10-digits',
        'Please enter a 10-digit US phone number',
        (value) => {
          const digits = (value || '').replace(/\D/g, '');
          const local =
            digits.length === 11 && digits.startsWith('1')
              ? digits.substring(1)
              : digits;
          return local.length === 10;
        }
      )
      .matches(phoneRegex, 'Please enter valid phone'),
    Address: Yup.string()
      .required('Please enter dropoff address')
      .trim('Please enter dropoff address'),
    StreetNumber: Yup.string().nullable(),
    Street: Yup.string()
      .required(
        'Your address does not have any street specified. Please select another address or choose address with street specified!'
      )
      .trim(
        'Your address does not have any street specified. Please select another address or choose address with street specified!'
      ),
    City: Yup.string()
      .required(
        'Your address does not have any city specified. Please select another address or choose address with city specified!'
      )
      .trim(
        'Your address does not have any city specified. Please select another address or choose address with city specified!'
      ),
    State: Yup.string()
      .required(
        'Your address does not have any state specified. Please select another address or choose address with state specified!'
      )
      .trim(
        'Your address does not have any state specified. Please select another address or choose address with state specified!'
      ),
    ZipCode: Yup.string()
      .required(
        'Your address does not have any zip code specified. Please select another address or choose address with zip code specified!'
      )
      .trim(
        'Your address does not have any zip code specified. Please select another address or choose address with zip code specified!'
      ),
    Email: Yup.string().when('HideEmail', {
      is: true,
      then: Yup.string().notRequired().nullable(),
      otherwise: Yup.string()
        .required('Email field is required!')
        .matches(emailRegex, 'Please enter valid email!')
    }),
    Subtotal: Yup.number().required('Please enter subtotal').min(1),
    Amount: Yup.number().when('CourierTip', {
      is: 'Custom',
      then: Yup.number().max(150, 'Please enter amount less than 150'),
      otherwise: Yup.number().nullable().notRequired()
    }),
    ItemCount: Yup.number()
      .required('Must have at least one item')
      .min(1, 'Must have at least one item'),
    Notes: Yup.object({
      apt: Yup.string().trim('The field cannot contain only spaces.'),
      floor: Yup.string().trim('The field cannot contain only spaces.'),
      entrance: Yup.string().trim('The field cannot contain only spaces.'),
      notes: Yup.string().trim('The field cannot contain only spaces.')
    }),
    Reason: Yup.string().when('IsV2', {
      is: true,
      then: Yup.string().required('Mandatory field').nullable(),
      otherwise: Yup.string().nullable().notRequired()
    }),
    AmountOfDrivers: Yup.number().when('Reason', {
      is: 'LARGE_ORDER',
      then: Yup.number()
        .required('Mandatory field')
        .min(1, 'Minimum is 1 courier')
        .max(5, 'Maximum is 5 couriers')
        .nullable(),
      otherwise: Yup.number().nullable().notRequired()
    })
    // Notes: Yup.string()
    //   .trim('The field cannot contain only spaces.')
    //   .max(
    //     250,
    //     'Delivery special instructions cannot be more than 50 characters'
    //   )
  })
  .test(function (value) {
    if (value.Address && !value.FullAddress) {
      return this.createError({
        path: 'Address',
        message: 'Please choose the suggested address from the dropdown!'
      });
    }
    return true;
  });

export default BookADriverSchema;
